import { Inventory2, Sell } from '@mui/icons-material';
import { Box, ToggleButton, ToggleButtonGroup, Typography, alpha, useTheme } from '@mui/material';
import type { CrmActivityDomain } from '@otw/models/leads/contacts';
import React from 'react';

interface CrmActivityDomainPillSliderProps {
  value: CrmActivityDomain;
  onChange: (domain: CrmActivityDomain) => void;
}

/**
 * Compact pill toggle for choosing Sales vs Inventory when logging CRM activity.
 */
export const CrmActivityDomainPillSlider: React.FC<CrmActivityDomainPillSliderProps> = ({
  value,
  onChange,
}) => {
  const theme = useTheme();

  return (
    <Box>
      <ToggleButtonGroup
        exclusive
        fullWidth
        size="small"
        value={value}
        onChange={(_, next: CrmActivityDomain | null) => {
          if (next) onChange(next);
        }}
        sx={{
          p: 0.5,
          borderRadius: 999,
          bgcolor: alpha(theme.palette.text.primary, 0.06),
          border: `1px solid ${alpha(theme.palette.divider, 0.9)}`,
          '& .MuiToggleButtonGroup-grouped': {
            border: 0,
            borderRadius: '999px !important',
            mx: 0,
            px: 2,
            py: 0.85,
            textTransform: 'none',
            fontWeight: 700,
            color: 'text.secondary',
            '&:not(:first-of-type)': {
              marginLeft: 0.25,
            },
            '&.Mui-selected': {
              bgcolor: theme.palette.background.paper,
              color: theme.palette.primary.main,
              boxShadow: `0 1px 4px ${alpha(theme.palette.common.black, 0.12)}`,
              '&:hover': {
                bgcolor: theme.palette.background.paper,
              },
            },
            '&:hover': {
              bgcolor: alpha(theme.palette.primary.main, 0.06),
            },
          },
        }}
      >
        <ToggleButton value="sales" aria-label="Sales">
          <Sell sx={{ fontSize: 16, mr: 0.75 }} />
          Sales
        </ToggleButton>
        <ToggleButton value="inventory" aria-label="Inventory">
          <Inventory2 sx={{ fontSize: 16, mr: 0.75 }} />
          Inventory
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};

export default CrmActivityDomainPillSlider;
